import React from "react";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";

// reactstrap components
import { Button, FormGroup, Container, Row, Col } from "reactstrap";

function MainFooter() {
  const [languageSelect, setLanguageSelect] = React.useState({
    value: "en",
    label: "English",
  });
  const [curencySelect, setCurencySelect] = React.useState({
    value: "USD",
    label: "USD",
  });

  function scrollToTop() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }

  return (
    <>
      <footer className="footer footer-big footer-black">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto text-center">
              <Row>
                <Col>
                  <div className="social-area">
                    <Button
                      className="btn-just-icon btn-round mr-1"
                      // color="instagram"
                      href="https://www.instagram.com/shannenvelasco_va/"
                      target="_blank"
                    >
                      <i class="fa fa-instagram"></i>
                    </Button>
                    <Button
                      className="btn-just-icon btn-round mr-1"
                      href="https://x.com/svelascova?lang=en>"
                      target="_blank"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-twitter-x"
                        viewBox="0 0 16 16"
                      >
                        <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                      </svg>
                    </Button>
                    <Button
                      className="btn-just-icon btn-round mr-1"
                      href="https://www.youtube.com/@ShannenVelasco_VA"
                      target="_blank"
                      // color="youtube"
                    >
                      <i class="fa fa-youtube"></i>
                    </Button>
                    <Button
                      className="btn-just-icon btn-round"
                      color="#f3ce13"
                      href="https://www.imdb.com/name/nm13639366/"
                      target="_blank"
                    >
                      <i className="fa fa-imdb" />
                    </Button>
                  </div>
                </Col>
              </Row>

              <hr />

              <div className="copyright">
                <div className="links">
                  <ul>
                    <li className="mr-1">
                      <a href="" onClick={() => scrollToTop()}>
                        <p>Back to Top</p>
                      </a>
                    </li>
                    •{" "}
                    <li className="mr-1">
                      <a href="*">
                        <p>Home</p>
                      </a>
                    </li>
                    •{" "}
                    <li className="mr-1">
                      <a href="about-me">
                        <p>About</p>
                      </a>
                    </li>
                    •{" "}
                    <li className="mr-1">
                      <a href="demos">
                        <p>Demos</p>
                      </a>
                    </li>
                    •{" "}
                    <li className="mr-1">
                      <a href="contact">
                        <p>Contact</p>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="text-center">
                  © {new Date().getFullYear()} Shannen Velasco
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default MainFooter;
